import { useState, useMemo } from "react";
import "./precuenta.css";
import AppShell from "../../page/AppShell/AppShell";
import MainContent from "../MainContent/MainContent";


const fmt = (n) => new Intl.NumberFormat("es-PA", { style: "currency", currency: "USD" }).format(n);
const fmtN = (n) => new Intl.NumberFormat("es-PA").format(n);
const ago = (min) => { const d = new Date(); d.setMinutes(d.getMinutes() - min); return d; };
const fmtTime = (d) => `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
const fmtDate = (d) => `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
const now = () => { const d = new Date(); return fmtTime(d); };

/* ═══ ICONS ══════════════════════════════════════════════════ */
const I = {
  Search: ({ s = 15 }) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>,
  Refresh: ({ s = 15 }) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="23 4 23 10 17 10" /><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" /></svg>,
  ChevDown: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="6 9 12 15 18 9" /></svg>,
  ChevLeft: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="15 18 9 12 15 6" /></svg>,
  ChevRight: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="9 18 15 12 9 6" /></svg>,
  Store: () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></svg>,
  Clock: () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>,
  User: () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>,
  Hash: () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="4" y1="9" x2="20" y2="9" /><line x1="4" y1="15" x2="20" y2="15" /><line x1="10" y1="3" x2="8" y2="21" /><line x1="16" y1="3" x2="14" y2="21" /></svg>,
  X: ({ s = 18 }) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>,
  Check: ({ s = 14 }) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="20 6 9 17 4 12" /></svg>,
  Trash: () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /></svg>,
  FileText: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" /></svg>,
  Printer: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="6 9 6 2 18 2 18 9" /><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" /><rect x="6" y="14" width="12" height="8" /></svg>,
  Receipt: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1-2-1z" /><line x1="8" y1="6" x2="16" y2="6" /><line x1="8" y1="10" x2="16" y2="10" /><line x1="8" y1="14" x2="12" y2="14" /></svg>,
  CreditCard: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><rect x="1" y="4" width="22" height="16" rx="2" /><line x1="1" y1="10" x2="23" y2="10" /></svg>,
  ShoppingBag: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" /><line x1="3" y1="6" x2="21" y2="6" /><path d="M16 10a4 4 0 0 1-8 0" /></svg>,
  Download: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" /></svg>,
  Eye: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg>,
  AlertCircle: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>,
  CheckCircle: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" /></svg>,
  XCircle: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><circle cx="12" cy="12" r="10" /><line x1="15" y1="9" x2="9" y2="15" /><line x1="9" y1="9" x2="15" y2="15" /></svg>,
  Monitor: () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="2" y="3" width="20" height="14" rx="2" /><line x1="8" y1="21" x2="16" y2="21" /><line x1="12" y1="17" x2="12" y2="21" /></svg>,
};

/* ═══ DATA ═══════════════════════════════════════════════════ */
const BRANCHES = ["Todas", "Don Lee Calle 50", "Don Lee Obarrio", "Don Lee Costa del Este", "Don Lee Vía España"];
const USERS = ["Caja 1 / María G.", "Caja 2 / Juan V.", "Caja 3 / Carlos R.", "Caja 4 / Ana L."];
const CLIENTS = ["Mesa 1", "Mesa 2", "Mesa 3", "Mesa 4", "Mesa 5", "Mesa 6", "Mesa 7", "Mesa 8", "Barra 1", "Barra 2", "Para llevar", "Delivery"];
const PRODS = [
  { name: "Clan A", cat: "Combo", price: 3.75, img: "🍔" },
  { name: "Clan B", cat: "Combo", price: 5.99, img: "🍕" },
  { name: "Coca-Cola", cat: "Bebida", price: 1.50, img: "🥤" },
  { name: "Papas Fritas", cat: "Snack", price: 2.25, img: "🍟" },
  { name: "Ensalada César", cat: "Entrada", price: 4.50, img: "🥗" },
  { name: "Alitas BBQ", cat: "Plato Fuerte", price: 6.75, img: "🍗" },
  { name: "Cheesecake", cat: "Postre", price: 3.25, img: "🍰" },
  { name: "Café Americano", cat: "Bebida", price: 1.75, img: "☕" },
  { name: "Cerveza", cat: "Bebida", price: 2.50, img: "🍺" },
  { name: "Nachos", cat: "Entrada", price: 4.00, img: "🧀" },
];

function genPrecuentas(n, status) {
  return Array.from({ length: n }, (_, i) => {
    const d = ago(~~(Math.random() * 240) + 5);
    const numProds = ~~(Math.random() * 4) + 1;
    const prods = Array.from({ length: numProds }, () => {
      const p = PRODS[~~(Math.random() * PRODS.length)];
      return { ...p, qty: ~~(Math.random() * 3) + 1, note: Math.random() > 0.7 ? "Sin cebolla" : "" };
    });
    const subtotal = prods.reduce((s, p) => s + p.price * p.qty, 0);
    const tax = +(subtotal * 0.07).toFixed(2);
    return {
      id: `PC-${String(5000 + i).padStart(5, "0")}`,
      orderId: `#${8200 + i}`,
      status,
      createdAt: d,
      client: CLIENTS[~~(Math.random() * CLIENTS.length)],
      user: USERS[~~(Math.random() * USERS.length)],
      machine: String(3900 + ~~(Math.random() * 100)),
      branch: BRANCHES[~~(Math.random() * (BRANCHES.length - 1)) + 1],
      products: prods,
      subtotal: +subtotal.toFixed(2),
      tax,
      total: +(subtotal + tax).toFixed(2),
      items: prods.reduce((s, p) => s + p.qty, 0),
    };
  });
}

/* ═══ MAIN ═══════════════════════════════════════════════════ */
export default function PrecuentasPanel() {
  const [tab, setTab] = useState("pendientes");
  const [pendientes] = useState(() => genPrecuentas(12, "pendiente"));
  const [eliminadas] = useState(() => genPrecuentas(5, "eliminada"));
  const [realizadas] = useState(() => genPrecuentas(18, "realizada"));

  const [branch, setBranch] = useState("Todas");
  const [branchDD, setBranchDD] = useState(false);
  const [lastRefresh, setLastRefresh] = useState(now());
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [detail, setDetail] = useState(null);

  const rpp = 8;
  const allData = tab === "pendientes" ? pendientes : tab === "eliminadas" ? eliminadas : realizadas;

  const filtered = useMemo(() => {
    let d = [...allData];
    if (branch !== "Todas") d = d.filter(r => r.branch === branch);
    if (search.trim()) { const q = search.toLowerCase(); d = d.filter(r => r.id.toLowerCase().includes(q) || r.client.toLowerCase().includes(q) || r.user.toLowerCase().includes(q)); }
    return d;
  }, [allData, branch, search]);

  const tp = Math.max(1, Math.ceil(filtered.length / rpp));
  const pd = filtered.slice((page - 1) * rpp, page * rpp);
  const pgN = () => { const ps = [], mx = 5; let st = Math.max(1, page - ~~(mx / 2)), en = Math.min(tp, st + mx - 1); if (en - st < mx - 1) st = Math.max(1, en - mx + 1); if (st > 1) { ps.push(1); if (st > 2) ps.push("…"); } for (let i = st; i <= en; i++) ps.push(i); if (en < tp) { if (en < tp - 1) ps.push("…"); ps.push(tp); } return ps; };

  const refresh = () => setLastRefresh(now());
  const switchTab = (t) => { setTab(t); setPage(1); setSearch(""); };

  const TABS = [
    { id: "pendientes", label: "Pendientes", icon: <I.AlertCircle />, count: pendientes.length, color: "#D97706" },
    { id: "eliminadas", label: "Eliminadas", icon: <I.XCircle />, count: eliminadas.length, color: "#C53030" },
    { id: "realizadas", label: "Realizadas", icon: <I.CheckCircle />, count: realizadas.length, color: "#1B8C1B" },
  ];

  const statusBadge = (s) => {
    const m = { pendiente: { bg: "#FEF3C7", c: "#D97706", l: "Pendiente" }, eliminada: { bg: "#FBE8E8", c: "#C53030", l: "Eliminada" }, realizada: { bg: "#E8FBE8", c: "#1B8C1B", l: "Realizada" } }[s];
    return <span className="pc-badge" style={{ background: m.bg, color: m.c }}>{m.l}</span>;
  };

  // Summary
  const totalAmount = filtered.reduce((s, r) => s + r.total, 0);
  const totalItems = filtered.reduce((s, r) => s + r.items, 0);

  return (



    <AppShell route="temporal">
      <MainContent>
        <div className="pc-root">
          <div className="pc-container">
            {/* TOP */}
            <div className="pc-top">
              <div>
                <div className="pc-top__title"><I.Receipt /> Precuentas</div>
                <div className="pc-top__sub"><I.Clock /> {lastRefresh} · Gestión de cuentas pendientes</div>
              </div>
              <div className="pc-top__right">
                <div style={{ position: "relative" }}>
                  <button className="pc-btn-s" onClick={() => setBranchDD(!branchDD)}>
                    <I.Store /> {branch === "Todas" ? "Sucursal" : branch.replace("Don Lee ", "")} <I.ChevDown />
                  </button>
                  {branchDD && <>
                    <div style={{ position: "fixed", inset: 0, zIndex: 99 }} onClick={() => setBranchDD(false)} />
                    <div className="pc-dd">
                      {BRANCHES.map(b => (
                        <button key={b} className={`pc-dd__item ${branch === b ? "pc-dd__item--active" : ""}`}
                          onClick={() => { setBranch(b); setBranchDD(false); setPage(1); }}>
                          {b === "Todas" ? "🏢" : "🏪"} {b}
                          {branch === b && <span style={{ marginLeft: "auto" }}><I.Check /></span>}
                        </button>
                      ))}
                    </div>
                  </>}
                </div>
                <button className="pc-btn-icon" onClick={refresh} title="Actualizar"><I.Refresh /></button>
                {/* <button className="pc-btn-icon" title="Exportar"><I.Download /></button> */}
              </div>
            </div>

            {/* TABS */}
            <div className="pc-tabs">
              {TABS.map(t => (
                <button key={t.id} className={`pc-tab ${tab === t.id ? "pc-tab--active" : ""}`} onClick={() => switchTab(t.id)}>
                  <span className="pc-tab__icon" style={{ color: tab === t.id ? t.color : "#9090A0" }}>{t.icon}</span>
                  <span className="pc-tab__label">{t.label}</span>
                  <span className="pc-tab__count" style={{ background: tab === t.id ? t.color + "18" : "#F0F0F5", color: tab === t.id ? t.color : "#9090A0" }}>{t.count}</span>
                </button>
              ))}
            </div>

            {/* SUMMARY CARDS */}
            <div className="pc-summary d-none">
              <div className="pc-summary-card">
                <div className="pc-summary-card__icon" style={{ background: "#5B5BD612", color: "#5B5BD6" }}><I.Receipt /></div>
                <div><div className="pc-summary-card__label">Precuentas</div><div className="pc-summary-card__value">{fmtN(filtered.length)}</div></div>
              </div>
              <div className="pc-summary-card">
                <div className="pc-summary-card__icon" style={{ background: "#1B8C1B12", color: "#1B8C1B" }}><I.ShoppingBag /></div>
                <div><div className="pc-summary-card__label">Items</div><div className="pc-summary-card__value">{fmtN(totalItems)}</div></div>
              </div>
              <div className="pc-summary-card">
                <div className="pc-summary-card__icon" style={{ background: "#D9770612", color: "#D97706" }}><I.CreditCard /></div>
                <div><div className="pc-summary-card__label">Monto total</div><div className="pc-summary-card__value">{fmt(totalAmount)}</div></div>
              </div>
            </div>

            {/* CONTENT */}
            <div className="pc-section">
              <div className="pc-section__head">
                <div className="pc-section__title">{TABS.find(t => t.id === tab)?.label}: {filtered.length}</div>
                <button className="pc-btn-icon" onClick={refresh}><I.Refresh /></button>
              </div>

              {/* Search */}
              <div className="pc-filter-row">
                <div className="pc-search-wrap">
                  <div className="pc-search-icon"><I.Search s={13} /></div>
                  <input className="pc-search-input" placeholder="Buscar por ID, mesa, cajero..." value={search} onChange={e => { setSearch(e.target.value); setPage(1); }} />
                </div>
              </div>

              {/* Cards grid */}
              {pd.length === 0 ? (
                <div className="pc-empty">
                  <div className="pc-empty__icon"><I.Receipt /></div>
                  <div className="pc-empty__title">Vacío</div>
                  <div className="pc-empty__desc">No hay precuentas {tab}</div>
                </div>
              ) : (
                <div className="pc-grid">
                  {pd.map(pc => (
                    <div key={pc.id} className="pc-card" onClick={() => setDetail(pc)}>
                      <div className="pc-card__head">
                        <div>
                          <div className="pc-card__id">{pc.id}</div>
                          <div className="pc-card__client"><I.User /> {pc.client}</div>
                        </div>
                        {statusBadge(pc.status)}
                      </div>
                      <div className="pc-card__body">
                        <div className="pc-card__prods">
                          {pc.products.slice(0, 3).map((p, i) => (
                            <div key={i} className="pc-card__prod">
                              <span className="pc-card__prod-img">{p.img}</span>
                              <span className="pc-card__prod-name">{p.name}</span>
                              <span className="pc-card__prod-qty">x{p.qty}</span>
                              <span className="pc-card__prod-price">{fmt(p.price * p.qty)}</span>
                            </div>
                          ))}
                          {pc.products.length > 3 && <div className="pc-card__prod-more">+{pc.products.length - 3} más</div>}
                        </div>
                      </div>
                      <div className="pc-card__foot">
                        <div className="pc-card__meta">
                          <span><I.Clock /> {fmtTime(pc.createdAt)}</span>
                          <span><I.Monitor /> {pc.user.split(" / ")[0]}</span>
                        </div>
                        <div className="pc-card__total">{fmt(pc.total)}</div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Pagination */}
              {filtered.length > rpp && (
                <div className="pc-pag">
                  <div className="pc-pag__info">Mostrando <b>{(page - 1) * rpp + 1}</b>–<b>{Math.min(page * rpp, filtered.length)}</b> de <b>{filtered.length}</b></div>
                  <div className="pc-pag__pages">
                    <button className="pc-page-btn" disabled={page <= 1} onClick={() => setPage(p => p - 1)}><I.ChevLeft /></button>
                    {pgN().map((p, i) => p === "…" ? <span key={`e${i}`} className="pc-pag__ell">…</span> : <button key={p} className={`pc-page-btn ${page === p ? "pc-page-btn--active" : ""}`} onClick={() => setPage(p)}>{p}</button>)}
                    <button className="pc-page-btn" disabled={page >= tp} onClick={() => setPage(p => p + 1)}><I.ChevRight /></button>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* DETAIL MODAL */}
          {detail && <DetailModal pc={detail} onClose={() => setDetail(null)} />}
        </div>

      </MainContent>
    </AppShell>

  );
}

/* ═══ DETAIL MODAL ═══════════════════════════════════════════ */
function DetailModal({ pc, onClose }) {
  const statusMap = { pendiente: { bg: "#FEF3C7", c: "#D97706", l: "Pendiente" }, eliminada: { bg: "#FBE8E8", c: "#C53030", l: "Eliminada" }, realizada: { bg: "#E8FBE8", c: "#1B8C1B", l: "Realizada" } };
  const st = statusMap[pc.status];

  return (
    <div className="pc-overlay" onClick={onClose}>
      <div className="pc-modal" onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div className="pc-modal__head">
          <div className="pc-modal__head-left">
            <div className="pc-modal__icon"><I.Receipt /></div>
            <div>
              <div className="pc-modal__title">Detalle de precuenta</div>
              <div className="pc-modal__id">{pc.id} · Orden {pc.orderId}</div>
            </div>
          </div>
          <button className="pc-modal__close" onClick={onClose}><I.X /></button>
        </div>

        {/* Body */}
        <div className="pc-modal__body">
          {/* Actions */}
          <div className="pc-modal__actions">
            <button className="pc-modal__act-btn"><I.FileText /> Descargar</button>
            <button className="pc-modal__act-btn pc-modal__act-btn--ghost"><I.Printer /> Imprimir</button>
          </div>

          {/* Info grid */}
          <div className="pc-modal__info-grid">
            <div className="pc-modal__info-cell"><div className="pc-modal__info-lbl">Mesa / Destino</div><div className="pc-modal__info-val">{pc.client}</div></div>
            <div className="pc-modal__info-cell"><div className="pc-modal__info-lbl">Cajero</div><div className="pc-modal__info-val">{pc.user}</div></div>
            <div className="pc-modal__info-cell"><div className="pc-modal__info-lbl">Sucursal</div><div className="pc-modal__info-val">{pc.branch.replace("Don Lee ", "")}</div></div>
            <div className="pc-modal__info-cell"><div className="pc-modal__info-lbl">Máquina</div><div className="pc-modal__info-val">{pc.machine}</div></div>
            <div className="pc-modal__info-cell"><div className="pc-modal__info-lbl">Hora</div><div className="pc-modal__info-val">{fmtTime(pc.createdAt)}</div></div>
            <div className="pc-modal__info-cell"><div className="pc-modal__info-lbl">Fecha</div><div className="pc-modal__info-val">{fmtDate(pc.createdAt)}</div></div>
          </div>

          {/* Status */}
          <div className="pc-modal__status">
            <span style={{ fontSize: 12, fontWeight: 600, color: "#6B6B80" }}>Estado</span>
            <span className="pc-badge" style={{ background: st.bg, color: st.c }}>{st.l}</span>
          </div>

          {/* Products */}
          <div className="pc-modal__section-lbl">Productos</div>
          <div className="pc-modal__products">
            {pc.products.map((p, i) => (
              <div key={i} className="pc-modal__product">
                <div className="pc-modal__prod-img">{p.img}</div>
                <div className="pc-modal__prod-info">
                  <div className="pc-modal__prod-name">{p.name}</div>
                  <div className="pc-modal__prod-cat">{p.cat}</div>
                  {p.note && <div className="pc-modal__prod-note">{p.note}</div>}
                </div>
                <div className="pc-modal__prod-right">
                  <div className="pc-modal__prod-qty">x{p.qty}</div>
                  <div className="pc-modal__prod-price">{fmt(p.price * p.qty)}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Footer: Totals */}
        <div className="pc-modal__footer">
          <div className="pc-modal__total-row"><span>Subtotal:</span><span>{fmt(pc.subtotal)}</span></div>
          <div className="pc-modal__total-row"><span>Impuesto 7%:</span><span>{fmt(pc.tax)}</span></div>
          <div className="pc-modal__total-row pc-modal__total-row--final"><span>Total:</span><span>{fmt(pc.total)}</span></div>
        </div>
      </div>
    </div>
  );
}

/* ═══ CSS ═════════════════════════════════════════════════════ */
const CSS = `

      `;